import {useTrackPageAndSessionView} from '../../hooks/useTrackPageAndSessionView';
import {
  availabilityPageType,
  reschedulePageType,
} from '../../utils/generatePageTracking';
import {useTrackPageData} from '../../hooks/useTrackPageData';

export const Tracking = ({
  pageType,
}: {
  pageType: typeof availabilityPageType | typeof reschedulePageType;
}) => {
  useTrackPageAndSessionView(pageType);
  useTrackPageData(pageType);

  return null;
};
